<template>
<div class="container">
     <div :style="styles.topBar">
        <button class="button__action" @click="goBack">
        <i class="glyphicon glyphicon-chevron-left icon"></i>
        Back to Sequences
        </button>
        <div class="button-container">
            <button class="button__action button__delete" @click="deleteSequence()">{{getActiveSequence.deleted ? 'Restore Sequence' : 'Delete Sequence' }}</button>
            <button class="button__action" @click="saveChanges()">Save Changes</button>
        </div>
    </div>
    <header :style="styles.pageHeader">
      <span v-if="!newSequence" :style="styles.historyIcon" @click="fetchHistory">
        <HistoryIcon/>&nbsp;
        History
        <!-- <i className="material-icons">
            {this.state.showHistory ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
        </i>-->
      </span>
      <div v-if="showHistory" @click="toggleHistoryPopup" :style="styles.closeHistory">
        <CloseIcon/>
      </div>
      <div v-if="showHistory" :style="styles.showHistoryContainer">
        <p v-if="noHistory" :style="styles.noHistory">No history</p>
        <ul :style="styles.historyList" v-if="!noHistory">
          <li
            :style="styles.historyListItem"
            v-for="(item, index) in history"
          >Sequence updated {{moment(item.updatedAt)}} by user.firstName</li>
        </ul>
      </div>
      <p v-if="!newSequence" :style="styles.pageHead">Edit Sequence</p>
      <p v-if="newSequence" :style="styles.pageHead">Create a New Sequence</p>
      <!-- <div
          :style="styles.editsWrapper(getSequenceStatus)">
          <button class="button__action" key="saveButton" @click="saveChanges(newSequence)"><i

              class="glyphicon glyphicon-check icon"
            ></i> Save</button>
      </div>-->
    </header>
    <div class="input__container" :class="{ 'form-group--error': $v.name.$error }">
      <label class="input__label">Name *</label>
      <input
        type="text"
        v-model="getActiveSequence.name"
        class="input__text"
        :class="{ 'error': $v.name.$error }"
      >
      <div class="error__hint" v-if="!$v.name.required">Sequence name is required</div>
      <label for="getActiveSequence.isActive">
          <input type="checkbox" v-model="getActiveSequence.isActive"> Active
      </label>
    </div>
    <div class="input__container subscription-container rule__control-group rule__control-group--select">
        <label class="input__label" for="">Subscription</label>
        <select class="form__select" v-model="getActiveSequence.subscription">
            <option :key="`${sub._id}-${index}`"
            v-for="(sub, index) in subscriptions" :value="sub._id">{{sub.name}}</option>
        </select>
    </div>
    <div class="input__container">
        <label class="input__label" for="getActiveSequence.description">Description</label>
        <textarea v-model="getActiveSequence.description" id="" cols="30" rows="10"></textarea>
    </div>
    <div class="input__container">
      <label class="input__label">Action Cards *</label>
    </div>
    <Spinner v-if="!newSequence && !getCards.length"/>
    <draggable
      v-model="getCards"
      :style="styles.wrapper(true)"
      v-if="newSequence || (!newSequence && getCards.length)"
      :options="{draggable:'.item'}"
    >
      <section v-for="(card, index) in getCards" :key="index" class="item cardWrap">
        <div :style="styles.indexContainer">
          <p :style="styles.indexNumber">{{index+1}}</p>
        </div>

        <div :style="styles.cardContianer">
          <p :style="styles.cardName">{{card.legacyName}}</p>
          <p>{{card.displayName}}</p>
        </div>
        <div :style="styles.iconContainer">
          <div @click="goToCard(card)">
            <PencilIcon
              :key="`${index}-editIcon`"
              class="material-icons"
              :style="styles.actionIcon"
            />
          </div>
          <div @click="removeCardFromSequence(index)">
            <DeleteIcon :style="styles.actionIcon"/>
          </div>
        </div>
      </section>
      <section key="addnew" class="cardWrap addCardWrap" @click="toggleAddCardToSequenceModal">
        <div :style="styles.cardContainer">
          <p :style="styles.cardName" v-if="!newSequence">Edit Sequence</p>
          <p :style="styles.cardName" v-if="newSequence">Build Sequence</p>
          <p>Add New Action Card</p>
        </div>
        <div :style="styles.iconContainer">
          <PlusCircleIcon style="font-size:1.6rem"/>
        </div>
      </section>
    </draggable>
    <div class="invalid input__container" v-if="showCardValidation && !getCards.length">
      <div class="error__hint error__custom">Please add at least one action card to the sequence.</div>
    </div>
  </div>
</div>
</template>

<script>
import store from '../../store';
import draggable from 'vuedraggable';
import { getResource, postResource } from '../../services/Utils.js';
import VueNotifications from 'vue-notifications';
import PencilIcon from 'vue-material-design-icons/Pencil';
import DeleteIcon from 'vue-material-design-icons/Delete';
import HistoryIcon from 'vue-material-design-icons/History';
import PlusCircleIcon from 'vue-material-design-icons/PlusCircle';
import CloseIcon from 'vue-material-design-icons/Close';
import Services from '../../services/Services';
import moment from 'moment';
import { required } from 'vuelidate/lib/validators';
import Spinner from '../general/Spinner';
export default {
  name: 'sequenceTemplate',
  components: {
    draggable,
    PencilIcon,
    DeleteIcon,
    HistoryIcon,
    Spinner,
    CloseIcon,
    PlusCircleIcon
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: '',
      icon: '❗️'
    }
  },
  props: {
    newSequence: Boolean
  },
  computed: {
    getActiveSequence: {
      get: function() {
        return store.getters.getActiveSequence;
      },
      set: function(sequence) {
        Services.setActiveSequence(sequence);
      }
    },
    getSequenceStatus() {
      return store.getters.getSequenceStatus;
    },
    getCards: {
      get() {
        return store.getters.getSequenceCards;
      },
      set(value) {
        store.commit('setSequenceCards', value);
      }
    }
  },
  methods: {
    goBack() {
      Services.clearActiveSequence();
      this.$router.push('/sequences');
    },
    deleteSequence() {
        if(this.getActiveSequence.deleted) {
            const update = {
                deleted: false,
                _id: this.$route.params.shortId
            }

            postResource(`/v1/sequences/delete`, false, update)
                .then((res) => {
                    this.getActiveSequence.deleted = false;
                    this.showSuccessMsg({
                        message: `${this.getActiveSequence.name} Sequence has been restored!`
                    });
                }).catch((err) => {
                    console.log(err);
                })
        } else {
            store.commit('showDeleteRecordModal', true);
        }
    },
    toggleAddCardToSequenceModal() {
      store.commit('showAddCardToSequenceModal', true);
    },
    createNewSequence() {
      this.$v.$touch();
      if (this.$v.$invalid || !this.getCards.length) {
        if (!this.getCards.length) {
          this.showCardValidation = true;
        }
      } else {
        let sequence = {};

        // need to add in validation
        // if(!this.title.length || !store.getters.getSequenceCards.length) {
        //   if(!this.title) {

        //   }

        //   return false;
        // }

        sequence.name = this.name;
        let newCards = this.getCards;

        let newCardArray = [];

        newCards.forEach(card => {
          if (card.ParameterizedTitles) {
            newCardArray.push(card.ParameterizedTitles.PartitionKey._);
          } else if (card.TrainingMedia) {
            newCardArray.push(card.TrainingMedia.PartitionKey._);
          }
        });

        sequence.templates = newCardArray;

        postResource('/v1/sequences/create', false, sequence)
          .then(res => {
            console.log('success!');
            this.showSuccessMsg({ message: 'Sequence created!' });
            return res;
          })
          .then(res => {
            console.log('our res', res);
            setTimeout(() => {
              Services.setActiveSequence(res.newSequence);
              this.$router.push(`/sequences/${res.newSequence._id}`);
            }, 600);
          })
          .catch(error => {
            this.showErrorMsg({
              message: 'An error occurred. Please try again.'
            });
          });
      }
    },
    goToCard(card) {
      let path = '';
      if (card.TrainingMedia) {
        path = card.TrainingMedia.PartitionKey._;
      } else if (card.ParameterizedTriggerScript) {
        path = card.ParameterizedTriggerScript.PartitionKey._;
      } else if (card.ParameterizedTitles) {
        path = card.ParameterizedTitles.PartitionKey._;
      }
      this.$router.push('/cards/' + card._id);
    },
    removeCardFromSequence(index) {
      const sequenceCards = [...this.getCards];

      sequenceCards.splice(index, 1);
      store.commit('setSequenceCards', sequenceCards);
      // Services.checkSequenceChanges();
    },
    saveChanges() {
      this.name = this.getActiveSequence.name;
      this.$v.$touch();

      if (this.$v.$invalid || !this.getCards.length) {
        if (!this.getCards.length) {
          this.showCardValidation = true;
        }
      } else {
        const sequence = this.getActiveSequence || {};

        sequence.name = this.name;

        const allSequenceCards = this.getCards;

        // legacy array with partition keys to support app
        const templatesArray = [];
        const actionCardIdArray = [];

        for (const i in allSequenceCards) {
          let card = allSequenceCards[i];
          templatesArray.push(card.legacyName);
          actionCardIdArray.push(card._id);
        }

        sequence.templates = templatesArray;
        sequence.actionCards = actionCardIdArray;

        if (this.newSequence) {
          postResource('/v1/sequences/create', false, sequence)
            .then(res => {
              console.log('success!');
              this.showSuccessMsg({ message: 'Sequence created!' });
              return res;
            })
            .then(res => {
              console.log('our res', res);
              setTimeout(() => {
                Services.setActiveSequence(res.newSequence);
                this.$router.push(`/sequences/${res.newSequence._id}`);
              }, 600);
            })
            .catch(error => {
              this.showErrorMsg({
                message: 'An error occurred. Please try again.'
              });
            });
        } else {
          postResource(
            '/v1/sequences/update',
            `sequenceId=${this.getActiveSequence._id}`,
            sequence
          )
            .then(res => {
              console.log(res);
              this.showSuccessMsg({ message: 'Sequence saved!' });
              return res;
            })
            .then(res => {
              Services.setActiveSequence(this.$route.params.shortId);
              store.commit('setSequenceStatus', false);
            })
            .catch(error => {
              this.showErrorMsg({
                message: 'An error occurred. Please try again.'
              });
            });
        }
      }
    },
    fetchSubscriptions() {
        getResource('/v1/subscriptions/list').then((res) =>{
            this.subscriptions = res.subscriptions;
        }).catch(err => {
            console.log(err)
        })
    },
    fetchHistory() {
      getResource(
        '/v1/history/single/',
        `recordType=Sequence&recordId=${this.getActiveSequence._id}`
      )
        .then(res => {
          if (res.record) {
            this.history = res.record.history;
            this.toggleHistoryPopup();
          } else {
            this.noHistory = true;
            this.toggleHistoryPopup();
          }
        })
        .catch(err => console.log('err'));
    },
    toggleHistoryPopup() {
      this.showHistory = !this.showHistory;
    },
    moment: function(date) {
      return moment(date).fromNow();
    }
  },
  mounted() {
      this.fetchSubscriptions();
    if (!this.newSequence) {
      // set active sequence
      Services.setActiveSequence(this.$route.params.shortId);
    }

    // Services.checkSequenceChanges();
  },
  validations: {
    name: {
      required
    }
  },
  created() {
    this.$v.$reset();
  },
  data() {
    return {
        subscriptions: [],
      showCardValidation: false,
      checkSequenceChanges: Services.checkSequenceChanges,
      showHistory: false,
      noHistory: false,
      history: {},
      name: '',
      saveText: 'Save',
      styles: {
        container: {
          padding: '2rem'
        },
        historyIcon: {
          display: 'flex',
          alignItems: 'center',
          margin: 'auto 10px',
          cursor: 'pointer',
          color: '#888'
        },
        topBar: {
          boxShadow: '0 0 8px 0 rgba(0,0,0,.1)',
          position: 'relative',
          zIndex: '99',
          boxSizng: 'border-box',
          display: 'flex',
          justifyContent: 'space-between',
          padding: '10px',
          width: '100%'
        },
        showHistoryContainer: {
          position: 'fixed',
          top: '60px',
          background: '#fff',
          overflowY: 'scroll',
          left: '220px',
          height: '300px',
          width: '350px',
          padding: '0',
          boxShadow: '0 2px 4px 1px rgba(0,0,0,0.2)',
          zIndex: '9999'
        },
        closeHistory: {
          position: 'absolute',
          left: '350px',
          top: '10px',
          cursor: 'pointer'
        },
        noHistory: {
          textAlign: 'center',
          padding: '20px'
        },
        historyList: {
          padding: '0',
          margin: '0',
          listStyle: 'none'
        },
        historyListItem: {
          borderBottom: '1px solid #ddd',
          padding: '10px'
        },
        wrapper: loaded => ({
          display: 'flex',
          flexFlow: 'row wrap',
          justifyContent: 'flex-start',
          padding: '0 10px',
          alignItems: 'flex-start',
          marginTop: '-10px',
          marginBottom: '1.5rem',
          width: '100%'
        }),
        pageHeader: {
          display: 'flex',
          padding: '0 10px',
          width: '100%',
          position: 'relative'
        },
        pageHead: {
          fontSize: '1.5em',
          maxWidth: '600px',
          margin: '20px auto',
          fontWeight: '700',
          color: '#aaa'
        },
        nav: {
          position: 'fixed',
          top: '0',
          left: '200px',
          right: '0',
          background: '#fff',
          boxShadow: '0 2px 5px 1px rgba(0,0,0,0.1)',
          height: '60px',
          zIndex: '99',
          padding: '10px',
          display: 'flex',
          flexFlow: 'row nowrap',
          alignItems: 'center'
        },
        navInputWrapper: {
          flex: '0 0 auto',
          width: '250px',
          padding: '10px',
          background: '#f5f5f5',
          border: '1px solid #eee',
          borderRadius: '5px',
          overflow: 'hidden',
          display: 'flex',
          flexFlow: 'row nowrap',
          alignItems: 'center'
        },
        navInput: {
          flex: '1',
          padding: '0',
          borderRadius: '0',
          border: '0',
          background: '#f5f5f5'
        },
        navInputIcon: {
          margin: 'auto 10px auto 0',
          color: '#888',
          fontSize: '1.25em'
        },
        toggleUploadModalButton: {
          background: '#09a3ed',
          fontSize: '0.9em',
          color: '#fff',
          borderRadius: '5px',
          padding: '5px 10px 5px 5px',
          margin: 'auto 0 auto auto',
          border: '0',
          display: 'flex',
          flexFlow: 'row nowrap',
          alignItems: 'center',
          ':hover': {
            cursor: 'pointer',
            opacity: '0.9'
          }
        },
        cardWrap: {
          background: '#fff',
          display: 'flex',
          border: '1px solid #eee',
          padding: '15px 10px 10px',
          flexFlow: 'row nowrap',
          width: 'calc(33.33% - 20px)',
          margin: '10px',
          '@media screen and (max-width: 1050px)': {
            width: '50%'
          },
          ':hover': {
            border: '1px solid #888',
            cursor: 'move'
          }
        },
        addCardWrap: {
          ':hover': {
            cursor: 'pointer'
          }
        },
        policyCardWrap: {
          ':hover': {
            border: '1px solid #eee',
            cursor: 'default'
          }
        },
        cardContainer: {
          display: 'flex',
          flexFlow: 'column nowrap'
          // cursor: 'move'
        },
        cardPreview: {
          background: 'teal',
          position: 'relative',
          padding: '20px'
        },
        cardName: {
          color: '#aaa',
          fontSize: '0.9em',
          marginBottom: '0px'
        },
        cardMetadataSection: {
          display: 'flex',
          flexFlow: 'column nowrap',
          padding: '40px',
          width: '100%'
        },
        cardType: {
          margin: '20px auto 10px 20px',
          color: '#888'
        },
        iconContainer: {
          margin: 'auto 5px auto auto',
          color: '#aaa',
          fontSize: '1.6rem',
          display: 'flex'
        },
        actionType: {
          margin: '0 auto 20px 20px',
          fontSize: '1.5em'
        },
        actionIcon: {
          cursor: 'pointer',
          fontSize: '1.6rem',
          ':hover': {
            color: '#777'
          }
        },
        tabWrap: {
          width: '100%',
          minHeight: '200px',
          margin: '0',
          display: 'flex',
          background: '#e8ffff',
          flexFlow: 'column nowrap'
        },
        tabList: {
          listStyle: 'none',
          display: 'flex',
          flexFlow: 'row nowrap',
          margin: '0',
          padding: '0'
        },
        tab: {
          flex: '1',
          padding: '10px',
          borderBottom: '5px solid #fff',
          textAlign: 'center'
        },
        indexContainer: {
          height: 'auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginRight: '30px'
        },
        indexNumber: {
          background: '#CCC',
          color: '#777',
          borderRadius: '50%',
          padding: '0.5rem 0',
          width: '30px',
          height: '30px',
          textAlign: 'center'
        },
        editsWrapper: display => ({
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'no-wrap',
          position: 'absolute',
          right: '1rem',
          top: '2rem',
          transition: 'all 0.3s',
          opacity: display ? '1' : '0',
          transform: display ? 'translateY(0)' : 'translateY(20px)'
        }),
        editsHint: display => ({
          color: '#AAA',
          fontSize: '1.6rem',
          position: 'relative',
          opacity: display ? '1' : '0',
          transition: 'all 0.2s',
          top: '5px'
        }),
        saveButton: {
          background: '#6ab04c',
          fontSize: '1.2rem',
          color: '#fff',
          borderRadius: '5px',
          padding: '5px 15px',
          margin: '-33px auto 10px',
          outline: '0',
          border: '0',
          width: '100px',
          ':hover': {
            opacity: '0.9'
          }
        },
        undoButton: {
          background: '#CCC',
          color: '#777',
          width: 'auto'
        },
        spinner: {
          bottom: 0,
          left: 0,
          margin: 'auto',
          position: 'absolute',
          right: 0,
          width: 65,
          height: 65,
          top: 0
        }
      }
    };
  }
};
</script>
<style lang="scss" scoped>
.item {
  cursor: move;
}

.cardWrap {
  background: #fff;
  display: flex;
  border: 1px solid #eee;
  padding: 15px 10px 10px;
  flex-flow: row nowrap;
  width: calc(33.33% - 20px);
  margin: 10px;
  @media screen and (max-width: 1050px) {
    width: 50%;
  }
  &:hover {
    border: 1px solid #888;
    cursor: move;
  }
}
.addCardWrap {
  &:hover {
    cursor: pointer;
  }
}

.input__container {
padding: 0 10px;
  margin-left: 0.5rem;

  textarea {
      display: block;
      max-width: 400px;
      width: 100%;
  }
}

.input__text {
  margin-bottom: 1rem;
}

.button__submit {
  display: block;
  margin-top: 60px;
}

.button__action {
  margin-top: 10px;
}

p {
  margin: 10px 0;
}

.button-container {
    display: flex;
}

.subscription-container {
    max-width: 400px;
    margin: 2rem 0.5rem;
}

.rule__control-group--select::after {
    top: 1.6rem;
    right: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/views/SequenceTemplate.vue